/* eslint-disable prefer-promise-reject-errors */
class TmpFileService {
  /**
   *
   * @param ossKey file key
   * @return Promise<any>
   */
  getFile2 (ossKey) {
    return new Promise(async (resolve, reject) => {
      try {
        const fileName = ossKey.substr(ossKey.lastIndexOf('/') + 1) // 兼容minio
        const data = {
          result: `${window.location.origin}/api/v2/bud/file/minio/download/${fileName}?ossKey=${ossKey.replace('test/', '')}`,
          success: true
        }
        if (data.success) {
          resolve({ success: true, url: data.result })
        } else {
          reject({ success: false })
        }
      } catch (e) {
        reject({ success: false, message: e })
      }
    })
  }
}

const tmpFileService = new TmpFileService()

export default tmpFileService
